import { Types } from '@store/types';

const initialState = {
	totalPages: 0,
	totalElements: 0,
	currentPage: 0,
	blockProductList: []
};

const BlockSuggestionsReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_BLOCK_PRODUCT_LIST:
			return {
				...state,
				totalPages: action.payload?.totalPages,
				totalElements: action.payload?.totalElements,
				currentPage: action.payload?.currentPage,
				blockProductList:
					action.payload.currentPage === 0
						? action.payload?.data
						: [...state.blockProductList, ...(action.payload?.data || [])]
			};
		default:
			return state;
	}
};

export default BlockSuggestionsReducer;
